// 各ハウスの収穫データ
export const farmDataByGreenhouse = {
    'PHHK-1': [
      // { date: '2023-10月', weight: 4157.00, revenue: 1600050 },
      // { date: '2023-11月', weight: 8248.00, revenue: 1895653 },
      { date: '2023-12月', weight: 5843.00, revenue: 929564 },
      { date: '2024-1月', weight: 5854.00, revenue: 1620000 },
      { date: '2024-2月', weight: 4969.00, revenue: 2406189 },
      { date: '2024-3月', weight: 4961.00, revenue: 2807279 },
      { date: '2024-4月', weight: 6621.00, revenue: 3085970 },
      { date: '2024-5月', weight: 6509.00, revenue: 2812687 },
      { date: '2024-6月', weight: 5851.00, revenue: 969160 },
      { date: '2024-7月', weight: 4685.00, revenue: 664241 },
      { date: '2024-8月', weight: 155.00, revenue: 27239 },
      { date: '2024-9月', weight: 0, revenue: 0 },
      { date: '2024-10月', weight: 2025.40, revenue: 0 },
      { date: '2024-11月', weight: 3620.66, revenue: 0 },
    ],
    'THSN': [
      // { date: '2023-9月', weight: 935.58, revenue: 0 },
      // { date: '2023-10月', weight: 3480.8, revenue: 0 },
      { date: '2023-11月', weight: 3265.13, revenue: 0 },
      { date: '2023-12月', weight: 3383.02, revenue: 0 },
      { date: '2024-1月', weight: 2496.1, revenue: 0 },
      { date: '2024-2月', weight: 1981.3, revenue: 0 },
      { date: '2024-3月', weight: 3333.3, revenue: 0 },
      { date: '2024-4月', weight: 4413.1, revenue: 0 },
      { date: '2024-5月', weight: 4585.2, revenue: 0 },
      { date: '2024-6月', weight: 4961.6, revenue: 0 },
      { date: '2024-7月', weight: 0, revenue: 0 },
      { date: '2024-8月', weight: 0, revenue: 0 },
      { date: '2024-9月', weight: 0, revenue: 0 },
      { date: '2024-10月', weight: 1840.99, revenue: 0 },
      { date: '2024-11月', weight: 2585.84, revenue: 0 },
    ],
    'SHINTOMI': [
      { date: '2023-10月', weight: 8.08, revenue: 0 },
      { date: '2023-11月', weight: 234.6, revenue: 0 },
    ],
    'AI': [
      { date: '2023-10月', weight: 0, revenue: 0 },
      { date: '2023-11月', weight: 0, revenue: 0 },
    ]
  };